import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, KeepAlive as _KeepAlive, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12072d58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "title mb_10" }
const _hoisted_3 = { key: 0 }

import { ref } from 'vue'
import ProductTable from './ProductTable.vue'
import ProductTableLink from './ProductTableLink.vue'
import { t } from '@/plugins/i18n'
import { isJA } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'hasSet', 'list', 'countryCode'],
  emits: ['update:visible', 'commit'],
  setup(__props, { emit }) {



const show = ref(true)

const tabs = [
  { label: '购物车商品', value: 0 },
  { label: '我的商品', value: 1 },
  { label: t('链接添加') + '&SKU', value: 2 }
].fort()

const tab = ref(0)

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
    "append-to-body": true,
    width: "1000px",
    top: "8vh",
    "destroy-on-close": "",
    onClosed: _cache[4] || (_cache[4] = ($event: any) => (emit('update:visible', null))),
    "custom-class": "group-product-panel",
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('添加商品')), 1),
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('禁用商品无法进行组合')), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (v) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: v.value,
                label: v.label,
                name: v.value
              }, {
                default: _withCtx(() => [
                  (v.value === 2)
                    ? (_openBlock(), _createBlock(_KeepAlive, { key: 0 }, [
                        _createVNode(ProductTableLink, {
                          list: __props.list,
                          key: v.label,
                          type: v.value,
                          hasSet: __props.hasSet,
                          onCommit: _cache[0] || (_cache[0] = (data) => {
              emit('commit', data)
              show.value = false
            })
                        }, null, 8, ["list", "type", "hasSet"])
                      ], 1024))
                    : (_openBlock(), _createBlock(_KeepAlive, { key: 1 }, [
                        _createVNode(ProductTable, {
                          list: __props.list,
                          key: v.label,
                          type: v.value,
                          hasSet: __props.hasSet,
                          onCommit: _cache[1] || (_cache[1] = (data) => {
              emit('commit', data)
              show.value = false
            }),
                          countryCode: __props.countryCode
                        }, null, 8, ["list", "type", "hasSet", "countryCode"])
                      ], 1024))
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})